import * as THREE from 'three';
import SafetyBarrierObject from './safety-barrier.object';

export default {
  name: 'safety-barrier-object',
  type: SafetyBarrierObject.types.EDGE_SLAB,
  camera2D: {
    position: new THREE.Vector3(10, 0, 0)
  }
};



// WEBPACK FOOTER //
// ./src/object-view/generators/safety-barrier/defaultOptions.js